import React from "react";
import AboutUs from "../components/AboutUsPage/about-us";
import Navbar from "../components/navbar";
const About = () => {
    return (
      <React.Fragment>
        <Navbar classNav="nav-dark-bg"/>
          <main className="about-us">
                <div className="container">
                  <AboutUs aboutTitle={"من نحن؟"} aboutDescription={"كساندرا هي اداه محاسبيه اقتصاديه ، تعليميه و تنظيميه. تم تصميم كساندرا لمقابله احتيجات سوق الاعمال و تحديدا لجميع رواد الاعمال و المقبلين على المشاريع الصغيره و المتوسطه الراغبين في الاستقلاليه و الاستدامه. نحن موؤسسه المعرفه الحديثه فخورين بتصميم هذا المنتج بايدي سعوديه و مقاييس عالميه لتلبية الطلب المتزايد على رايدة الاعمال و دراسات الجدوى"}/>
                  <AboutUs aboutTitle={"قصتنا"} aboutDescription={"المشاريع TREND مع الشعب. من هنا بدات عندي فكرة كساندرا ، بما اني دارس اقتصاد و محاسبه ماليه و خبرتي في المجال المالي. قررت ان كل قريب و حبيب يستحق يحقق احلامه لكن يحتاج يبدأ صح."}/>
                  <AboutUs aboutTitle={"رسالتنا"} aboutDescription={"لا يوجد مشروع فاشل و من واجبنا تحقيق النجاح و دعم المشاريع لتصبح من حلم الى و اقع."}/>
                  <AboutUs aboutTitle={"رؤيتنا"} aboutDescription={"كسر كل الحواجز و الصور النمطيه للمشاريع و جعلها في منتاول الجميع."}/>
                </div>
            </main>
      </React.Fragment>

    );
  };
  
  export default About;